/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React, {useState} from 'react'
import {ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material'
import {Favorite} from '../../../../model/favorites'
import {DeleteForever, Edit} from '@mui/icons-material'
import {FormattedMessage} from 'react-intl'
import DeleteFavoriteDialog from './dialog/DeleteFavoriteDialog'
import EditFavoriteDialog from './dialog/EditFavoriteDialog'

interface Props {
  anchorEl: Element | undefined
  setAnchorEl: (el: Element | undefined) => void
  favorite: Favorite
}

export const FavoriteContextMenu: React.FC<Props> = ({
  anchorEl,
  setAnchorEl,
  favorite
}) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)

  const closeMenu = () => {
    setAnchorEl(undefined)
  }

  const confirmDeletion = (open: boolean) => {
    setOpenDeleteDialog(open)
    closeMenu()
  }

  const editFavorite = (open: boolean) => {
    setOpenEditDialog(open)
    closeMenu()
  }

  return (
    <div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        keepMounted
        onClose={closeMenu}
      >
        <MenuItem
          data-testid='FavoriteContextMenu:menu_edit_favorite'
          onClick={() => editFavorite(true)}
        >
          <ListItemIcon>
            <Edit color={'primary'} />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage
              id='FavoriteOptions.EditFavorite'
              defaultMessage='Edit favorite'
            />
          </ListItemText>
        </MenuItem>
        <MenuItem
          data-testid='FavoriteContextMenu:menu_delete_favorite'
          onClick={() => confirmDeletion(true)}
        >
          <ListItemIcon>
            <DeleteForever color={'primary'} />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage
              id='FavoriteOptions.DeleteFavorite'
              defaultMessage='Delete favorite'
            />
          </ListItemText>
        </MenuItem>
      </Menu>
      <DeleteFavoriteDialog
        open={openDeleteDialog}
        onClose={() => confirmDeletion(false)}
        favorite={favorite}
      />
      <EditFavoriteDialog
        open={openEditDialog}
        onClose={() => editFavorite(false)}
        favorite={favorite}
      />
    </div>
  )
}
